'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _class, _temp; /*
                    * Copyright 2015, Yahoo Inc.
                    * Copyrights licensed under the New BSD License.
                    * See the accompanying LICENSE file for terms.
                    */

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _universalIntl = require('@alife/universal-intl');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FormattedMessage = (_temp = _class = function (_Component) {
  _inherits(FormattedMessage, _Component);

  function FormattedMessage() {
    _classCallCheck(this, FormattedMessage);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  FormattedMessage.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var values = this.props.values;
    var nextValues = nextProps.values;


    if (!(0, _util.shallowEquals)(nextValues, values)) {
      return true;
    }

    return false;
  };

  FormattedMessage.prototype.render = function render() {
    var _props = this.props,
        intlName = _props.intlName,
        id = _props.id,
        description = _props.description,
        defaultMessage = _props.defaultMessage,
        values = _props.values,
        _props$tagName = _props.tagName,
        tagName = _props$tagName === undefined ? 'span' : _props$tagName,
        component = _props.component,
        children = _props.children,
        props = _objectWithoutProperties(_props, ['intlName', 'id', 'description', 'defaultMessage', 'values', 'tagName', 'component', 'children']);

    var intl = (0, _universalIntl.injectIntl)({ name: intlName });

    var tokenDelimiter = void 0;
    var tokenizedValues = void 0;
    var elements = void 0;

    var hasValues = values && Object.keys(values).length > 0;
    if (hasValues) {
      // Creates a token with a random UID that should not be guessable or
      // conflict with other parts of the `message` string.
      var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

      var generateToken = function () {
        var counter = 0;
        return function () {
          return 'ELEMENT-' + uid + '-' + (counter += 1);
        };
      }();

      // Splitting with a delimiter to support IE8. When using a regex
      // with a capture group IE8 does not include the capture group in
      // the resulting array.
      tokenDelimiter = '@__' + uid + '__@';
      tokenizedValues = {};
      elements = {};

      // Iterates over the `props` to keep track of any React Element
      // values so they can be represented by the `token` as a placeholder
      // when the `message` is formatted. This allows the formatted
      // message to then be broken-up into parts with references to the
      // React Elements inserted back in.
      Object.keys(values).forEach(function (name) {
        var value = values[name];

        if ((0, _react.isValidElement)(value)) {
          var token = generateToken();
          tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
          elements[token] = value;
        } else {
          tokenizedValues[name] = value;
        }
      });
    }

    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var formatMessage = intl.formatMessage.bind(intl);
    var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

    var nodes = void 0;

    var hasElements = elements && Object.keys(elements).length > 0;
    if (hasElements) {
      // Split the message into parts so the React Element values captured
      // above can be inserted back into the rendered message. This
      // approach allows messages to render with React Elements while
      // keeping React's virtual diffing working properly.
      nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
        return !!part;
      }).map(function (part) {
        return elements[part] || part;
      });
    } else {
      nodes = [formattedMessage];
    }

    if (typeof children === 'function') {
      return children.apply(undefined, _toConsumableArray(nodes));
    }

    var comp = component || tagName;

    // Needs to use `createElement()` instead of JSX, otherwise React will
    // warn about a missing `key` prop with rich-text message formatting.
    return _react.createElement.apply(undefined, [comp, props].concat(_toConsumableArray(nodes)));
  };

  return FormattedMessage;
}(_react.Component), _class.displayName = 'FormattedMessage', _class.propTypes = {
  intlName: _propTypes2['default'].string,
  id: _propTypes2['default'].string.isRequired,
  description: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
  defaultMessage: _propTypes2['default'].string,
  values: _propTypes2['default'].object,
  component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].instanceOf(_react.Component)]),
  tagName: _propTypes2['default'].string,
  children: _propTypes2['default'].func
}, _class.defaultProps = {
  values: {}
}, _temp);
exports['default'] = FormattedMessage;
module.exports = exports['default'];